import { atom, useAtomValue } from 'jotai';
import chatttSDK from 'services/chattt';

export const chatttVersionState = atom(async () => {
  if (chatttSDK) {
    const version = await chatttSDK?.app?.getVersion();
    return `v${version}`;
  }
  return null;
});
export const useChatttVersion = () => useAtomValue(chatttVersionState);
